import {StyleSheet} from 'react-native';

import {cloudLight, grayscale} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    // maxWidth: 350,
    minWidth: 250,
  },
  currentValue: {
    minHeight: 40,
  },
  currentValueText: {
    fontSize: 36,
    lineHeight: 40,
  },
  infoIcon: {
    color: grayscale,
  },
  infoButton: {
    outlineWidth: 0,
    outlineStyle: 'none',
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginBottom: 8,
  },
  listItem: {
    paddingVertical: 8,
  },
  headerListItem: {
    paddingTop: 0,
  },
  sdlmValue: {
    alignSelf: 'flex-end',
  },
  delta: {
    justifyContent: 'flex-end',
  },
  value: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
